import { useState } from 'react';
import { formatCpfCnpjInput } from '../../../../components/GetOrders/utils';
import {
  ModalActions,
  ModalBackdrop,
  ModalButton,
  ModalCard,
  ModalError,
  ModalInput,
  ModalText,
  ModalTitle,
} from './styles';
import type { DeepLinkResolveModalProps } from './types';
import { normalizeDocumentField } from './utils';

export function DeepLinkResolveModal({
  orderId,
  idGar,
  loading,
  errorMessage,
  onSubmit,
  onCancel,
}: DeepLinkResolveModalProps) {
  const [document, setDocument] = useState('');
  const [fieldError, setFieldError] = useState<string | undefined>(undefined);

  const form = normalizeDocumentField(document);
  const pedidoEcommerce = orderId?.trim() || undefined;
  const idGarPayload = idGar?.replace(/\D/g, '') || undefined;
  const hasOrderRef = Boolean(pedidoEcommerce);
  const hasGarRef = Boolean(idGarPayload);

  const handleSubmit = () => {
    setFieldError(undefined);
    if (!form.isValidCpfCnpj) {
      setFieldError('Informe um CPF ou CNPJ válido.');
      return;
    }

    if (!hasOrderRef && !hasGarRef) {
      setFieldError('Não há pedido na URL para completar.');
      return;
    }

    onSubmit({
      ...(pedidoEcommerce ? { order_id: pedidoEcommerce, pedidoEcommerce } : {}),
      ...(idGarPayload ? { idGar: idGarPayload } : {}),
      document: form.docDigits,
    });
  };

  return (
    <ModalBackdrop role="dialog" aria-modal="true">
      <ModalCard>
        <ModalTitle>Completar busca do pedido</ModalTitle>

        {hasOrderRef ? (
          <ModalText>
            Pedido: <strong>{orderId}</strong>
          </ModalText>
        ) : null}

        {hasGarRef ? (
          <ModalText>
            Pedido: <strong>{idGar}</strong>
          </ModalText>
        ) : null}

        <ModalText>Informe o CPF ou CNPJ do titular para continuar.</ModalText>
        <ModalInput
          type="text"
          inputMode="numeric"
          placeholder="CPF ou CNPJ do titular"
          maxLength={18}
          value={document}
          onChange={(e) => setDocument(formatCpfCnpjInput(e.target.value))}
          disabled={loading}
        />

        {fieldError ? <ModalError>{fieldError}</ModalError> : null}
        {errorMessage ? <ModalError>{errorMessage}</ModalError> : null}

        <ModalActions>
          <ModalButton type="button" onClick={onCancel} disabled={loading}>
            Cancelar
          </ModalButton>
          <ModalButton
            type="button"
            $primary
            onClick={handleSubmit}
            disabled={loading || !form.canSubmit || (!hasOrderRef && !hasGarRef)}
          >
            {loading ? 'Carregando...' : 'Continuar'}
          </ModalButton>
        </ModalActions>
      </ModalCard>
    </ModalBackdrop>
  );
}
